module.exports = __webpack_public_path__ + "img/logo_180410.84df9c42.svg";